import { render, staticRenderFns } from "./DocumentoModal.vue?vue&type=template&id=58da5e5b&scoped=true"
import script from "./DocumentoModal.vue?vue&type=script&lang=js"
export * from "./DocumentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58da5e5b",
  null
  
)

export default component.exports